import * as React from 'react';

import { useSoftwareKeyboardHeight } from '../../common/hooks/useSoftwareKeyboardHeight';

interface IProps {
  isModalOpen: boolean;
}

// Выставляет нижний отступ для модалок, чтобы клавиатура на мобилке не перекрывала инпуты
export function useAdaptModalToOpenedKeyboard({ isModalOpen }: IProps) {
  // Нужно чтобы словить ref когда элемент появится в DOM, а не сразу после рендера
  // элемент рендерится не сразу из-за портала
  const [modalElement, setModalElement] = React.useState<HTMLDivElement | null>(null);
  const handleModalRef = React.useCallback((element: HTMLDivElement | null) => {
    setModalElement(element);
  }, []);
  const softwareKeyboardHeight = useSoftwareKeyboardHeight();
  const isKeyboardOpened = softwareKeyboardHeight > 0;

  // Обрабатываем открытие клавиатуры, чтобы избежать перекрытия модалки
  React.useLayoutEffect(() => {
    if (isModalOpen && modalElement) {
      modalElement.style.paddingBottom = `${softwareKeyboardHeight}px`;

      return () => {
        modalElement.style.paddingBottom = '';
      };
    }

    return undefined;
  }, [isModalOpen, modalElement, softwareKeyboardHeight]);

  return { handleModalRef, isKeyboardOpened };
}
